"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.frameworks = exports.randomName = exports.decryptValue = exports.encryptValue = exports.allFrameworks = exports.detectFramework = exports.createLogger = exports.log = void 0;
var logger_1 = require("./logger");
Object.defineProperty(exports, "log", { enumerable: true, get: function () { return logger_1.log; } });
Object.defineProperty(exports, "createLogger", { enumerable: true, get: function () { return logger_1.createLogger; } });
var framework_1 = require("./framework");
Object.defineProperty(exports, "detectFramework", { enumerable: true, get: function () { return framework_1.detectFramework; } });
Object.defineProperty(exports, "allFrameworks", { enumerable: true, get: function () { return framework_1.allFrameworks; } });
var encryption_1 = require("./encryption");
Object.defineProperty(exports, "encryptValue", { enumerable: true, get: function () { return encryption_1.encryptValue; } });
Object.defineProperty(exports, "decryptValue", { enumerable: true, get: function () { return encryption_1.decryptValue; } });
var name_1 = require("./name");
Object.defineProperty(exports, "randomName", { enumerable: true, get: function () { return name_1.randomName; } });
var frameworks_json_1 = require("./constants/frameworks.json");
Object.defineProperty(exports, "frameworks", { enumerable: true, get: function () { return __importDefault(frameworks_json_1).default; } });
